import React, { useContext } from "react";
import { Link } from "react-router-dom";

import SearchContext from "contexts/SearchContext";

import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";

function NavBreadcrumb({ cuisine }) {
  // "setContextSearchValue" variable used to provide/update Search context
  const [contextSearchValue, setContextSearchValue] = useContext(SearchContext);

  // Reset Search context to empty when getting all recipes on Home page
  const clearSearch = function(event) {
    setContextSearchValue("");
  };

  return (
    <>
      <Breadcrumbs sx={{ my: 1 }} separator="›" aria-label="breadcrumb">
        <Link key="1" to="/recipes" onClick={clearSearch} style={{ color: "inherit", textDecoration: "none" }}>
          RECIPES
        </Link>
        <Typography key="2" color="inherit">
          {cuisine}
        </Typography>
      </Breadcrumbs>
    </>
  );
}

export default NavBreadcrumb;